import { useMutationHook, useQueryHook } from "@/hooks"
import type { DashboardConfig } from "@/types/dashboard"
import { readDashboard, updateDashboard } from "@/app/api/dashboard"

/** 대시보드 조회 — API에서 content JSON string 파싱까지 처리됨 */
export const useDashboardQuery = () => {
  return useQueryHook<DashboardConfig, unknown>({
    queryKey: ["readDashboard"],
    queryFn: () => readDashboard(),
  })
}

export const useUpdateDashboardMutation = () => {
  return useMutationHook(updateDashboard, ["readDashboard"])
}
